import { IExcelFile } from './parseExcelInIframe';
import { normalizeColumnName } from './columnUtils';

function hasDataInSheet(rows: (string | number)[][]): boolean {
    if (rows.length === 0) return false;
    return rows.some((row) => row.some((cell) => String(cell).trim() !== ''));
}

export function detectHeaders(firstRow: (string | number)[]): boolean {
    if (firstRow.length === 0) return false;
    const firstCell = firstRow[0];
    const lastCell = firstRow[firstRow.length - 1];
    return (
        firstCell !== null &&
        firstCell !== undefined &&
        String(firstCell).trim() !== '' &&
        lastCell !== null &&
        lastCell !== undefined &&
        String(lastCell).trim() !== ''
    );
}

export interface AutoImportResult {
    shouldAutoImport: boolean;
    sheetName?: string;
    columnMapping?: Record<number, number>;
    hasHeaders?: boolean;
}

export function shouldAutoImportExcel(excelData: IExcelFile, expectedColumns: string[]): AutoImportResult {
    const sheetNames = Object.keys(excelData.sheets);
    if (sheetNames.length === 0) {
        return { shouldAutoImport: false };
    }

    const filledSheets = sheetNames.filter((name) => hasDataInSheet(excelData.sheets[name].rows));

    if (filledSheets.length !== 1) {
        return { shouldAutoImport: false };
    }

    const sheetName = filledSheets[0];
    const sheet = excelData.sheets[sheetName];

    if (sheet.rows.length === 0) {
        return { shouldAutoImport: false };
    }

    const firstRow = sheet.rows[0];
    const hasHeaders = detectHeaders(firstRow);

    if (!hasHeaders) {
        return { shouldAutoImport: false };
    }

    const mapping: Record<number, number> = {};
    const normalizedHeaders = firstRow.map(normalizeColumnName);
    
    expectedColumns.forEach((expectedCol, expectedIdx) => {
        const normalizedExpectedCol = normalizeColumnName(expectedCol);
        const excelColIdx = normalizedHeaders.indexOf(normalizedExpectedCol);
        if (excelColIdx !== -1) {
            mapping[expectedIdx] = excelColIdx;
        }
    });

    const allColumnsMapped = expectedColumns.every((_, idx) => mapping[idx] !== undefined);

    if (allColumnsMapped) {
        return {
            shouldAutoImport: true,
            sheetName,
            columnMapping: mapping,
            hasHeaders: true,
        };
    }

    return { shouldAutoImport: false };
}
